import { PayloadAction } from '@reduxjs/toolkit';
import { IDesignerSelectionState, IDesignerViewState } from './IDesignerViewState';

export function setSelectionReducer(
  state: IDesignerViewState,
  action: PayloadAction<IDesignerSelectionState>,
) {
  state.selection = action.payload;
}
